import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { RootErrorBoundary } from './components/ErrorBoundary';
// Enforce pure light mode and standard typography across entire portal
document.documentElement.classList.remove('dark', 'font-small', 'font-large');
try {
  localStorage.removeItem('lg_darkmode');
  localStorage.removeItem('lg_font_size');
} catch {}

ReactDOM.createRoot(document.getElementById('root')).render(<RootErrorBoundary><App /></RootErrorBoundary>);
